import gql from 'graphql-tag'

const deleteStandardOrderMutation = gql`
mutation CA_Mutation_deleteStandardOrderValues($id: ID!) {
	cashAssist {
		deleteStandardOrderValues(id: $id) {
			id
		}
	}
}`

export default deleteStandardOrderMutation
